(() => {
  if (window.toscaniIdentity) return;
  window.toscaniIdentity = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  let scenes = [], frame = 0;
  const animateIn = (element, index = 0) => {
    if (window.toscaniMotion?.reveal(element, index)) return;
    if (reduced.matches || !element.animate) return;
    const animation = element.animate([
      { opacity: 0.2, transform: 'perspective(1000px) translateY(32px) rotateX(24deg)' },
      { opacity: 1, transform: 'perspective(1000px) translateY(0) rotateX(0)' }
    ], { duration: 850, delay: Math.min(index * 85, 255), easing: 'cubic-bezier(.16,1,.3,1)' });
    animations.add(animation);
    animation.onfinish = animation.oncancel = () => animations.delete(animation);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      animateIn(entry.target, Number(entry.target.dataset.tcIndex || 0));
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 }) : null;
  const update = () => {
    frame = 0;
    if (reduced.matches || document.hidden) return;
    scenes.forEach(scene => {
      const rect = scene.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = Math.max(-1, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      scene.querySelectorAll('[data-tc-card]').forEach((card, index) => {
        card.style.setProperty('--tc-lift', `${progress * (index === 1 ? -30 : 22)}px`);
        card.style.setProperty('--tc-tilt', `${progress * (index === 0 ? -8 : 8)}deg`);
      });
    });
  };
  const schedule = () => { if (!frame && !reduced.matches) frame = requestAnimationFrame(update); };
  const sceneObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('tc-inview', entry.isIntersecting));
  }, {threshold: 0}) : null;
  const init = () => {
    scenes = [...document.querySelectorAll('[data-tc-scene][data-tc-motion="true"]')];
    scenes.forEach(scene => { if (sceneObserver) sceneObserver.observe(scene); else scene.classList.add('tc-inview'); });
    scenes.forEach(scene => scene.querySelectorAll('[data-tc-reveal]').forEach((element, index) => {
      if (element.dataset.tcReady) return;
      element.dataset.tcReady = 'true';
      element.dataset.tcIndex = String(index % 3);
      if (observer && !reduced.matches) observer.observe(element);
    }));
    // Existing catalog headings share the identity without hiding products or controls.
    document.querySelectorAll('.toscani-store #MainContent .ts-catalog-heading h1, .toscani-home #MainContent .shopify-section:not(:has(.tc)):not(:has(.tm-hero)) h2').forEach(element => {
      if (element.dataset.tcReady) return;
      element.dataset.tcReady = 'true';
      if (observer && !reduced.matches) observer.observe(element);
    });
    schedule();
  };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tc-ready]').forEach(element => observer?.unobserve(element));
    scenes.filter(scene => event.target.contains(scene)).forEach(scene => sceneObserver?.unobserve(scene));
    scenes = scenes.filter(scene => !event.target.contains(scene));
  });
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-tc-ready]').forEach(element => {
      observer?.unobserve(element);
      element.getAnimations().forEach(animation => animation.cancel());
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      animations.forEach(animation => animation.cancel());
      observer?.disconnect();
      scenes.forEach(scene => scene.querySelectorAll('[data-tc-card]').forEach(card => {
        card.style.removeProperty('--tc-lift'); card.style.removeProperty('--tc-tilt');
      }));
    } else schedule();
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', () => { scenes.forEach(scene => scene.classList.toggle('tc-motion-paused', document.hidden)); schedule(); });
  init();
})();
